import React from 'react'
import $ from 'jquery'
import '../utility/csrf'
import GlobalBanner from '../common/globalBanner'
import AmountWrapper from '../common/amountWrapper'
import SubHeader from '../common/subHeader'
import NextButton from '../common/nextButton'
import CancelAndReturn from '../common/cancelAndReturn'
import GuestButton from '../guest/guestButton'
import templateData from '../utility/getTemplateData'

import appStore from '../stores/AppStore'
import appActions from '../actions/AppActions'

import { handleLogIn, handleGuest, handleTokenReuse } from '../utility/helper'

import * as FPT from '../utility/fpt'

let currentState = templateData.currentState
let LandingPage = React.createClass({

	contextTypes: {
		router: React.PropTypes.object.isRequired
	},

	getInitialState() {
		return {
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl
		};
	},

	componentDidMount() {
		appActions.updateCurrentPage({ currentPage: 'landing' });
		$('.spinneroverlay').hide();
	},

	getFPTDATA() {
		return {
			amount: appStore.getDonationAmount(),
			code: appStore.getDonationCode(),
			symbol: appStore.getDonationSymbol()
		}
	},

	handleGuest (event) {
		event.preventDefault();
		let donationAmount = appStore.getDonationAmount()
		if (donationAmount && parseFloat(donationAmount) >= 0.01) {
			// Tracking click event with data. 'Pay by card with amount'
			FPT.trackLinkClick('donateWithCard')
		}
		handleGuest(this)
	},

	handleNext (event) {
		event.preventDefault();
		let donationAmount = appStore.getDonationAmount()
		if (donationAmount && parseFloat(donationAmount) >= 0.01) {
			FPT.trackLinkClick('donateWithPayPal')
		}

		handleLogIn()
	},

	render() {
		return (
			<div className="donate_wrapper">
				<div className="container">
					{this.state.hasLogo ? <GlobalBanner /> : null}
					<SubHeader
						donationId={this.state.donationId}
						orgName={this.state.orgName}
						label={this.state.subHeaderLabel}/>
					<AmountWrapper />
					<p className="err_update_amount text-center">Some thing went wrong, please try after some time</p>
					<NextButton
						handleNext={this.handleNext}/>
					<GuestButton
						handleGuest={this.handleGuest}/>
					<CancelAndReturn />
				</div>
			</div>
		)
	}
})

export default React.createClass({
	contextTypes: {
		router: React.PropTypes.object.isRequired
	},

	getInitialState: function() {

		return {
			displayLanding: currentState ? false : true
		};
	},

	componentDidMount() {

		if (currentState) {
			this.context.router.push(currentState)
		} else {
			handleTokenReuse();
		}
	},

	componentWillUnmount() {},

	render() {
		return (
			<div>
				{this.state.displayLanding ? <LandingPage /> : null}
			</div>
			)
	}
})



// WEBPACK FOOTER //
// ./landing/landing.js